(function () {
  'use strict';

  let angular = window.angular;
  let $ = window.jQuery;

  UsersTable.$inject = [
    'Manager',
    'Admin',
    'SupportAdmin',
    '$element',
    '$timeout',
    '$uibModal',
    '$state',
    'AppUtils',
    '$translate',
    '$rootScope',
  ];

  angular.module('app').component('usersTable', {
    template:'<div class="col-xs-12 marginT5"><table ng-attr-id="{{$ctrl.componentId}}" class="table table-hover no-wrap" style="width: 100%"><thead><tr><th></th><th></th><th></th><th></th><th></th></tr></thead></table></div>',
    controller: UsersTable,
    controllerAs: '$ctrl',
    bindings: {
      users: '<',
      timeZones: '<',
      countries: '<',
      userType: '<',
      edit: '<?',
      remove: '<?',
      unlink: '<?',
      view: '<?',
      vars: '<?',
      componentId: '<?',
    },
  });

  function UsersTable(
    Manager,
    Admin,
    SupportAdmin,
    $element,
    $timeout,
    $uibModal,
    $state,
    utils,
    $translate,
    $root
  ) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.userType = vm.userType || 'Manager';
      vm.componentId = vm.userType + '-table';
      vm.usersMap = utils.arrayToObject(vm.users, 'id');
      vm.edit = typeof vm.edit === 'boolean' ? vm.edit : false;
      vm.remove = typeof vm.remove === 'boolean' ? vm.remove : false;
      vm.view = typeof vm.view === 'boolean' ? vm.view : true;
      initUsersTable(vm.users);
    };

    function initUsersTable(data) {
      let btnWidth = 28;
      // edit + password buttons, plus room for the resend-activation button,
      // which also depends on vm.edit but only shows on unverified rows —
      // the column width is fixed for the whole table, so it has to account
      // for it even though not every row displays it.
      btnWidth = vm.edit ? btnWidth + 3 * 33 : btnWidth;
      btnWidth = vm.remove ? btnWidth + 33 : btnWidth;
      btnWidth = vm.unlink ? btnWidth + 33 : btnWidth;

      let dtOptions = {
        processing: true,
        searching: true,
        lengthChange: false,
        info: false,
        data: data,
        columns: [
          {
            data: 'name',
            title: $translate.instant('entities._all.name'),
            render: function (data, type, row) {
              return row.name + ' ' + (row.surname || '');
            },
          },
          {
            data: 'id',
            title: $translate.instant('entities._all.username'),
            render: function (data, type, row) {
              return row.username || '';
            },
          },
          {
            data: 'email',
            title: $translate.instant('entities._all.email'),
            render: emptyRenderer,
          },
          {
            data: 'emailVerified',
            title: $translate.instant('entities.user.status.title'),
            render: statusRenderer,
          },
          {
            data: 'id',
            render: buttonsRenderer,
            orderable: false,
            width: btnWidth + 'px',
          },
        ],
      };

      $timeout(function () {
        $element.find('#' + vm.componentId).DataTable(dtOptions);
      });

      $element.on('click', '.table-buttons .btn', function () {
        let _this = $(this);

        let id = _this.data('entity');
        let op = _this.data('operation');
        switch (op) {
          case 'view':
            showUser(id);
            break;
          case 'edit':
            showUserForm(id);
            break;
          case 'remove':
            showRemoveModal(id);
            break;
          case 'password':
            showPasswordModal(id);
            break;
          case 'resend':
            resendActivation(id);
            break;
          case 'unlink':
            showUnlinkModal(id);
            break;
          default:
            console.log('invalid operation');
        }
      });
    }

    function showUser(id) {
      $uibModal
        .open({
          animation: false,
          bindToController: true,
          size: 'lg',
          backdrop: 'static',
          component: 'accountProfileShow',
          resolve: {
            user: function () {
              return vm.usersMap[id];
            },
            userType: function () {
              return vm.userType;
            },
            timeZones: function () {
              return vm.timeZones;
            },
            countries: function () {
              return vm.countries;
            },
          },
        })
        .result.catch(function (err) {
          console.log(err);
        });
    }

    function showUserForm(id) {
      let component =
        {
          Manager: 'managerForm',
          Admin: 'adminForm',
          SupportAdmin: 'supportAdminForm',
        }[vm.userType] ?? 'managerForm';

      let resolve = {
        user: function () {
          return vm.usersMap[id];
        },
        customerId: function () {
          return vm.usersMap[id].customerId;
        },
        timezones: function () {
          return vm.timeZones;
        },
        countries: function () {
          return vm.countries;
        },
      };
      if (vm.userType == 'SupportAdmin') {
        resolve = {
          user: function () {
            return vm.usersMap[id];
          },
          vars: function () {
            return vm.vars;
          },
        };
      }
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        size: 'lg',
        component: component,
        resolve: resolve,
      });

      instance.result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showRemoveModal(id) {
      $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          windowClass: 'modal-xs modal-warning',
          component: 'managerRemoveModal',
          resolve: {
            user: function () {
              return vm.usersMap[id];
            },
            // Borrar un Admin por /Managers responde 200 sin borrar nada.
            model: function () {
              return userModel();
            },
          },
        })
        .result.then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showUnlinkModal(id) {
      $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          windowClass: 'modal-xs modal-warning',
          component: 'supportAdminUnlinkModal',
          resolve: {
            user: function () {
              return vm.usersMap[id];
            },
            varId: function () {
              return $root.varId;
            },
          },
        })
        .result.then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showPasswordModal(id) {
      $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          component: 'managerPasswordForm',
          resolve: {
            user: function () {
              return vm.usersMap[id];
            },
          },
        })
        .result.then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function userModel() {
      return { Manager: Manager, Admin: Admin, SupportAdmin: SupportAdmin }[vm.userType] || Manager;
    }

    function resendActivation (id) {
      const user = vm.usersMap[id];
      const Model = userModel();

      $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        windowClass: 'modal-xs',
        component: 'resendActivationModal',
        resolve: {
          user: function () { return user; },
          model: function () { return Model; },
        },
      });
    }

    function emptyRenderer (data) {
      return data || '';
    }

    function statusRenderer (emailVerified) {
      if (emailVerified) {
        return `<span class="label label-success">${$translate.instant('entities.user.status.active')}</span>`;
      }

      return `<span class="label label-warning">${$translate.instant('entities.user.status.inactive')}</span>`;
    }

    function buttonsRenderer (data, type, row) {
      const $user = $translate.instant('entities.user.modelName');

      let buttons = '<div class="table-buttons">';
      if (vm.view) {
        buttons += `
                <button class="btn btn-primary btn-xs" data-operation="view" data-entity="${data}"
                    title="${$translate.instant('buttons.show')} ${$user}">
                    <i class="fas fa-fw fa-eye"></i>
                </button>`;
      }

      if (vm.edit) {
        buttons += `<button class="btn btn-warning btn-xs marginL5" data-operation="edit" data-entity="${data}"
                        title="${$translate.instant('buttons.edit')} ${$user}">
                    <i class="fas fa-fw fa-edit"></i>
                </button>`;
      }

      if (vm.unlink) {
        buttons += `<button class="btn btn-danger btn-xs marginL5" data-operation="unlink" data-entity="${data}"
                        title="${$translate.instant('buttons.unlink')} ${$user}">
                    <i class="fas fa-fw fa-unlink"></i>
                </button>`;
      }

      if (vm.remove) {
        buttons += `<button class="btn btn-danger btn-xs marginL5" data-operation="remove" data-entity="${data}"
                        title="${$translate.instant('buttons.delete')} ${$user}">
                    <i class="fas fa-fw fa-times"></i>
                </button>`;
      }

      if (vm.edit) {
        buttons += `<button class="btn btn-primary btn-xs marginL5" data-operation="password" data-entity="${data}"
                        title="${$translate.instant('buttons.change')} ${$translate.instant('entities._all.password')}">
                    <i class="fas fa-fw fa-key"></i>
                </button>`;
      }

      if (vm.edit && !row.emailVerified) {
        buttons += `<button class="btn btn-info btn-xs marginL5" data-operation="resend" data-entity="${data}"
                        title="${$translate.instant('entities.user.status.resendActivation')}">
                    <i class="fas fa-fw fa-paper-plane"></i>
                </button>`;
      }

      buttons += '</div>';
      return buttons;
    }
  }
})();
